import _ from 'underscore';
import Spinner from 'spin.js/spin.js';

import BaseButton from 'source/lib/component/button/base';

import template from './template.html';

const SPINNER = Symbol('spinner');

const SubmitButton = BaseButton.extend({
    name: 'submit-button',
    template,
    defaultSpinnerOptions: {
        lines: 11, // The number of lines to draw
        length: 5, // The length of each line
        width: 2, // The line thickness
        radius: 5, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#fff', // #rgb or #rrggbb or array of colors
        speed: 1.1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: '50%', // Top position relative to parent
        left: '22px', // Left position relative to parent
    },
    spinner() {
        this[SPINNER] = this[SPINNER] || new Spinner(this.spinnerOptions);

        return this[SPINNER];
    },
    initialize(options = {}) {
        this.spinnerOptions = _.extend(this.defaultSpinnerOptions, options.spinnerOptions);
        BaseButton.prototype.initialize.call(this, options);
        this.bindElements();
    },
    bindElements() {
        this.$throbbingElement = this.$('.js-auth-throbbing-element');
        this.$root.on('component:all:waiting:start', _.bind(this.startWaiting, this));
        this.$root.on('component:all:waiting:stop', _.bind(this.stopWaiting, this));
    },
    click(event) {
        this.components.proxyEvent('click', event, this);
        if (this.globalSubmitDisabled()) {
            return false;
        }
        return true;
    },
    startWaiting() {
        this.disable();
        this.spinner().spin(this.$throbbingElement[0]);
        this.$throbbingElement.addClass('button-airy__waiting');
    },
    onFormError() {
        this.stopWaiting();
    },
    stopWaiting() {
        this.enable();
        this.spinner().stop();
        this.$throbbingElement.removeClass('button-airy__waiting');
    },
});

export default SubmitButton;
